/** @file A world point snapped to the grid when this drag snaps (setting XOR Ctrl). */
import { dragModifiers } from '@pose2d/editor-geometry/dragModifiers';
import { snapPoint } from '@pose2d/editor-geometry/snapPoint';
import type { Vec2 } from '@pose2d/math/types';
import type { ToolContext, ViewportPointer } from '../../panels/viewport/viewportTypes';

/** Writes into and returns `w` (R-E1-10). */
export function snappedWorld(ctx: Pick<ToolContext, 'snap' | 'grid'>, p: ViewportPointer, w: Vec2): Vec2 {
  return dragModifiers(ctx.snap, p).snap ? snapPoint(ctx.grid, w[0], w[1], w) : w;
}
